export default __webpack_public_path__ + "static/media/home-business-tab-img02.2487cf7e.jpg";